<template>
	<div ref="map"></div>
</template>

<script>

	import GoogleMapsLoader from 'google-maps';

	export default {

		props: {
			places: {},
			itemLink: {},
			open: {},
			lang: {
				default: 'fr',
			},
			currentPosition: {},
			autoFit: {
				type: Boolean,
				default: true
			},
			zoommap: {
				default: 20,
			},
			resetmap: {
				default: false,
			},
			button_text: {},
			button_title: {},
		},

		data() {
			return {
				map: null,
				placesBounds: null,
				markers: [],
				cluster: null,
				rendering: true,

				mapStyles: [
					{
						'featureType': 'administrative',
						'elementType': 'labels.text.fill',
						'stylers': [
							{
								'color': '#444444'
							}
						]
					},
					{
						'featureType': 'landscape',
						'elementType': 'all',
						'stylers': [
							{
								'color': '#f2f2f2'
							}
						]
					},
					{
						'featureType': 'poi',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'poi.park',
						'elementType': 'geometry.fill',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#c2ebaf'
							}
						]
					},
					{
						'featureType': 'poi.park',
						'elementType': 'labels.text',
						'stylers': [
							{
								'visibility': 'on'
							}
						]
					},
					{
						'featureType': 'road',
						'elementType': 'all',
						'stylers': [
							{
								'saturation': -100
							},
							{
								'lightness': 45
							}
						]
					},
					{
						'featureType': 'road',
						'elementType': 'geometry.fill',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#ffffff'
							}
						]
					},
					{
						'featureType': 'road',
						'elementType': 'geometry.stroke',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#e1e1e1'
							}
						]
					},
					{
						'featureType': 'road.highway',
						'elementType': 'geometry.fill',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#ffffff'
							}
						]
					},
					{
						'featureType': 'road.highway',
						'elementType': 'geometry.stroke',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#e2e2e2'
							}
						]
					},
					{
						'featureType': 'road.arterial',
						'elementType': 'geometry.fill',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#ffffff'
							}
						]
					},
					{
						'featureType': 'road.arterial',
						'elementType': 'geometry.stroke',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#e1e1e1'
							}
						]
					},
					{
						'featureType': 'road.arterial',
						'elementType': 'labels.icon',
						'stylers': [
							{
								'visibility': 'off'
							},
							{
								'saturation': '0'
							}
						]
					},
					{
						'featureType': 'road.local',
						'elementType': 'geometry.stroke',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#e1e1e1'
							}
						]
					},
					{
						'featureType': 'road.local',
						'elementType': 'labels.icon',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'water',
						'elementType': 'all',
						'stylers': [
							{
								'color': '#46bcec'
							},
							{
								'visibility': 'on'
							}
						]
					},
					{
						'featureType': 'water',
						'elementType': 'geometry.fill',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'saturation': '0'
							},
							{
								'color': '#aadaff'
							}
						]
					}
				],
				mapClusterStyles: [
					{
						width: 40,
						height: 53,
						anchor: [-15, 0],
						iconAnchor: [20, 58],
						textColor: '#ffffff',
						textSize: 14
					}
				],
				infoWindow: null
			}
		},

		computed: {

			prettyPlaces() {
				return this.places.map((place) => {

					let geo = place.geolocation

					if(typeof geo === 'string') {
						geo = {
							lat: place.geolocation.split(',')[0],
							lng: place.geolocation.split(',')[1]
						}
					}

					return {
						id: place.id,
						name: place.name,
						slug: place.slug,
						kitchens: place.kitchens,
						address: place.address,
						isGold: place.isGold,
						position: {
							lat: parseFloat(geo.lat),
							lng: parseFloat(geo.lng)
						},
					}
				})
			}
		},

		watch: {
			prettyPlaces() {
				GoogleMapsLoader.load(() => {
					this.render()
				});
			}
		},

		mounted() {
			GoogleMapsLoader.LANGUAGE = this.lang;
			GoogleMapsLoader.load(() => {
				this.init()
			});
		},

		methods: {

			init() {
				this.initMap()
				this.initInfoWindow()
				this.initCluster()
				this.render()
			},

			initMap() {

				let options = {
					zoom: 1,
					center: new google.maps.LatLng('50.8503396', '4.351710300000036'),
					styles: this.mapStyles,
					mapTypeControlOptions: {
						mapTypeIds: ['roadmap', 'satellite']
					},
					zoomControlOptions: {
						position: 6
					},
					streetViewControlOptions: {
						position: 6
					}
				}

				this.map = new google.maps.Map(this.$refs.map, options);

				let zoommap = this.zoommap
				google.maps.event.addListener(this.map, 'idle', () => {

					if (this.map.getZoom() > zoommap) {
						this.map.setZoom(zoommap);
					}

					if(!this.rendering) {
						this.$emit('afterUserUpdate')
					}

					this.rendering = false
				});
			},

			initInfoWindow() {
				this.infoWindow = new google.maps.InfoWindow({
					pixelOffset: new google.maps.Size(0, -25)
				});
			},

			initCluster() {

				let getGoogleClusterInlineSvg = function () {
					let encoded = window.btoa('<svg aria-hidden="true" data-prefix="fas" data-icon="map-marker" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#E33042" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z" class=""></path></svg>');
					return ('data:image/svg+xml;base64,' + encoded);
				};

				this.mapClusterStyles[0].url = getGoogleClusterInlineSvg()

				this.cluster = new MarkerClusterer(this.map, this.markers, {
					imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
					gridSize: 40,
					maxZoom: 17,
					averageCenter: true,
					styles: this.mapClusterStyles
				});
			},

			render() {

				this.rendering = true

				// Remove Markers
				this.markers.forEach((marker) => {
					marker.setMap(null)
				});

				// Create Position Marker
				// new google.maps.Marker({
				//	 position: this.currentPosition,
				//	 map: this.map,
				// });

				// Create Places Markers
				this.markers = []
				this.prettyPlaces.forEach((place) => {
					this.markers.push(this.placeToMarker(place))
				})

				// Places Markers Clusters
				this.cluster.clearMarkers()
				this.cluster.addMarkers(this.markers)

				// Apply Bounds
				this.placesBounds = new google.maps.LatLngBounds()

				this.markers.forEach((marker) => {
					this.placesBounds.extend(marker.getPosition())
				})

				if(this.autoFit) {
					// Check If We Have Markers
					if(this.markers.length === 0) {
						let bxl = {lat: 50.8503396, lng: 4.351710300000036}
						this.map.setCenter(bxl)
					} else {
						this.map.fitBounds(this.placesBounds)
					}
				}

				this.closeInfoWindow()
			},

			placeToMarker(place) {

				let icon = {
					path: 'M9.5266,14.7463 C6.5006,14.7463 4.0476,12.2933 4.0476,9.2623 C4.0476,6.2343 6.5006,3.7853 9.5266,3.7853 C12.5506,3.7853 15.0076,6.2343 15.0076,9.2623 C15.0076,12.2933 12.5506,14.7463 9.5266,14.7463 M9.5696,0.0003 C4.2856,0.0003 0.0006,4.2583 0.0006,9.5083 C0.0006,12.1953 2.6366,17.0083 2.6366,17.0083 L9.2186,28.1763 L16.0866,17.1373 C16.0866,17.1373 19.1366,12.5473 19.1366,9.5083 C19.1406,4.2583 14.8546,0.0003 9.5696,0.0003',
					fillColor: '#35B7AA',
					fillOpacity: 1,
					anchor: new google.maps.Point(9,28),
					strokeWeight: 0,
					scale: 1.5
				}
				if(place.isGold) icon.fillColor = '#ba9f6f'

				const marker =  new google.maps.Marker({
					position: place.position,
					map: this.map,
					// animation: google.maps.Animation.DROP,
					title: place.name,
					icon: icon
				})

				marker.addListener('click', () => {
					this.openInfoWindow(place)
				})

				return marker
			},

			openInfoWindow(place) {

				let content
				if(place.isGold) {
					content = `
						<div class="infoWindowRmap">
							<a href="${this.itemLink.replace("%slug%", place.slug)}" style="font-weight: bold" class="color-gold">${place.name}</a><br>
							<small style="color: #8b8b8b">${place.kitchens}</small><br>
							<small>${place.address}</small>
						</div>
					`
				} else {
					content = `
						<div class="infoWindowRmap">
							<a href="${this.itemLink.replace("%slug%", place.slug)}" style="font-weight: bold" class="color-pass">${place.name}</a><br>
							<small style="color: #8b8b8b">${place.kitchens}</small><br>
							<small>${place.address}</small>
						</div>
					`
				}

				this.infoWindow.setContent(content)
				this.infoWindow.setPosition(place.position)
				this.infoWindow.open(this.map)
			},

			closeInfoWindow() {
				this.infoWindow.close(this.map)
			},

			hoverMarker(id) {

				const marker = this.markers.find((marker) => {
					return marker.title == id
				})

				marker.setAnimation(google.maps.Animation.BOUNCE)
			},

			leaveMarker(id) {

				const marker = this.markers.find((marker) => {
					return marker.title == id
				})

				marker.setAnimation(null)
			},

			getBounds() {
				return this.map.getBounds()
			}

		}


	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/maps/RMap.vue